import { z } from 'zod';
import { PasswordSchema } from '../auth/password';
import { PatientDataSchema } from './patientData';
import { notificationPreferences, ParticipantSchema } from './entity';

export const OnboardingDataSchema = z.object({
  password: PasswordSchema,
  patientData: PatientDataSchema,
  notificationPreference: z.enum(notificationPreferences),
  phone: z
    .string()
    .regex(/^\+[1-9]\d{1,15}$/)
    .optional(),
});

export type OnboardingData = z.infer<typeof OnboardingDataSchema>;

export const CompleteOnboardingRequestSchema = z.object({
  invitationId: z.string().uuid(),
  email: z.string().email(),
  password: PasswordSchema,
  patientData: PatientDataSchema,
  notificationPreference: z.enum(notificationPreferences),
  phone: z
    .string()
    .regex(/^\+[1-9]\d{1,15}$/)
    .optional(),
});

export type CompleteOnboardingRequest = z.infer<
  typeof CompleteOnboardingRequestSchema
>;

export const CompleteOnboardingResponseSchema = z.object({
  participant: ParticipantSchema,
  accessToken: z.string(),
  refreshToken: z.string(),
});

export type CompleteOnboardingResponse = z.infer<
  typeof CompleteOnboardingResponseSchema
>;

export const InviteeSchema = z.object({
  email: z.string().email(),
  hasPassword: z.boolean(),
  hasPatientData: z.boolean(),
  studyId: z.string().uuid(),
});

export type Invitee = z.infer<typeof InviteeSchema>;
